module.exports = __webpack_public_path__ + "img/HDFC SKY Logo.ff9026ea.svg";